import { render } from "./Introduction.vue?vue&type=template&id=0f2c500c&scoped=true"
import script from "./Introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./Introduction.vue?vue&type=script&setup=true&lang=js"

import "./Introduction.vue?vue&type=style&index=0&id=0f2c500c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2c500c"],['__file',"src/components/UserTest/Introduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f2c500c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f2c500c', __exports__)) {
    api.reload('0f2c500c', __exports__)
  }
  
  module.hot.accept("./Introduction.vue?vue&type=template&id=0f2c500c&scoped=true", () => {
    api.rerender('0f2c500c', render)
  })

}


export default __exports__